export default __webpack_public_path__ + "static/media/LOGO.dadee10f.png";